import styled from 'styled-components';
import { BLACK, BLUE, NEUTRAL_100, WHITE } from "@styles/colors";
import { INTER } from "@styles/fonts";
import BackgroundImageUrl from "@assets/images/LightGradientBackground.png";
import { safeAreaInset } from '@lib/telegram';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const ContentContainer = styled.div`
  padding: 16px 12px 100px 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 16px 12px 24px 12px;
  padding-bottom: ${safeAreaInset().bottom || 24}px;
  background-color: ${WHITE};
`;

// Payment Details Card Styled Components
export const DetailsCard = styled.div`
  padding: 16px 12px;
  border: 1px solid ${NEUTRAL_100};
  border-radius: 16px;
  color: black;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const DetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${NEUTRAL_100};
`;

// Payment Information Card Styled Components
export const InformationCard = styled.div`
  background-image: url(${BackgroundImageUrl});
  background-size: cover;
  background-position: center;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  padding: 24px 0;
  gap: 16px;
`;

export const BankInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
`;

export const BankLogo = styled.img`
  width: 54px;
  aspect-ratio: 16 / 11;
  margin-bottom: 8px;
`;

export const BankAccountName = styled.span`
  font-family: ${INTER.bold};
  font-size: 16px;
  color: ${BLACK};
`;

export const BankAccountTag = styled.span`
  font-family: ${INTER.regular};
  font-size: 16px;
  color: ${BLUE};
`;

export const BankAccountDetails = styled.span`
  font-family: ${INTER.regular};
  font-size: 16px;
  color: ${BLACK};
`;

export const EditIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: ${WHITE};
  border-radius: 100%;
  cursor: pointer;
`;

export const DisclaimerContainer = styled.div`
  padding: 0 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DisclaimerText = styled.span`
  text-align: center;
`;
